import axiosInstance from "axiosConfig";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { toast } from "react-toastify";
import { SESSION_QUERY_KEY } from './CheckSessionHook'
import { queryClient } from 'App'

export type ChangeSuccessorPasswordPayload = {
  password: string;
};

export const useChangeSuccessorPassword = (
  options?: UseMutationOptions<any, unknown, ChangeSuccessorPasswordPayload>
) => {
  return useMutation({
    mutationKey: ["changeSuccessorPassword"],
    mutationFn: async ({ password }: ChangeSuccessorPasswordPayload) => {
      const { data } = await axiosInstance.post(`/successors/change-password`, { password });
      return data;
    },
    onMutate: (variables) => {
      Toast({
        id: "changeSuccessorPassword",
        message: "Zapisywanie nowego hasła...",
        type: TOAST_TYPES_ENUM.LOADING,
      });
      return options?.onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        id: "changeSuccessorPassword",
        message: "Hasło zostało zmienione",
        type: TOAST_TYPES_ENUM.SUCCESS,
      });
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error: any, variables, context) => {
    queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      const status =
        error?.status ??
        error?.response?.status ??
        (typeof error?.code === "number" ? error.code : undefined);

      const apiMsg =
      error?.response?.data?.message ||
        (status === 422
          ? "Nie można ustawić nowego hasła"
          : status === 404
          ? "Użytkownik nie znaleziony"
          : status === 500
          ? "Błąd serwera"
          : "Wystąpił nieoczekiwany błąd");

      Toast({
        id: "changeSuccessorPassword",
        message: apiMsg,
        type: TOAST_TYPES_ENUM.ERROR,
      });

      if (status !== 422 && status !== 404 && status !== 500) {
        toast.dismiss("changeSuccessorPassword");
      }
      options?.onError?.(error, variables, context);
    },
  });
};
